'use strict';

import { queryFirst, queryAll, addClass, removeClass, remove, scrollTo, throttle } from '../domUtil';

import { initOnce, getNestedValue } from '../util';

const $window = $(window);
const $document = $(document);
const $body = $('body');
const activeClass = 'active';

const getOffsetTop = element => {
    let offsetTop = 0;
    while (element) {
        offsetTop += element.offsetTop;
        element = element.offsetParent;
    }
    return offsetTop;
};

const handleDesktopCarousel = carousel => {
    let indicators = queryFirst('.image-slide-indicators', carousel);

    if (window.matchMedia('(min-width: 768px)').matches) {
        removeClass(carousel, 'slide');

        let slideItem = queryFirst('.slider-inner .slider-item:first-of-type', carousel);

        if (slideItem && indicators) {
            if (!slideItem.offsetHeight) {
                setTimeout(() => {
                    slideItem = queryFirst('.slider-inner .slider-item:first-of-type', carousel);

                    if (slideItem) {
                        const slideIndicatorPosition = slideItem.offsetTop + (slideItem.offsetHeight - indicators.offsetHeight) / 2;

                        indicators.style.top = slideIndicatorPosition + 'px';
                    }
                }, 2400);
            } else {
                const slideIndicatorPosition = slideItem.offsetTop + (slideItem.offsetHeight - indicators.offsetHeight) / 2;

                indicators.style.top = slideIndicatorPosition + 'px';
            }
        }

        $(carousel).on('slide.bs.carousel', function (e) {
            e.preventDefault();

            const headerHeight = queryFirst('header.main-header').offsetHeight;

            scrollTo($(e.relatedTarget).offset().top - headerHeight);
        });
    } else {
        addClass(carousel, 'slide');

        if (indicators) {
            removeClass(indicators, 'position-fixed');
            indicators.style.top = '';
        }
    }
};

const handleCarouselOnScroll = carousel => {
    let currentScrollPos = window.scrollY || window.pageYOffset;
    let ticking = false;

    const carouselIndicatorScroll = () => {
        ticking = false;
        if (window.matchMedia('(min-width: 768px)').matches) {
            const indicators = queryFirst('.image-slide-indicators', carousel);
            const sliderContainer = carousel.closest('.scrollable-product-item');
            const sliderContainerOffsetTop = getOffsetTop(sliderContainer);
            const sliderContainerOffsetEnd = sliderContainerOffsetTop + sliderContainer.offsetHeight - queryFirst('.slider-item', carousel).offsetHeight + indicators.offsetHeight / 2;
            if (sliderContainerOffsetTop < currentScrollPos && sliderContainerOffsetEnd >= currentScrollPos) {
                addClass(indicators, 'position-fixed');
            } else {
                removeClass(indicators, 'position-fixed');
            }

            const scrollDistance = -sliderContainer.getBoundingClientRect().top + 200;

            let activeIndex = 1;
            queryAll('.slider-item', carousel).some((el, i) => {
                if (el.offsetTop < scrollDistance && scrollDistance < el.offsetTop + el.offsetHeight) {
                    activeIndex = i + 1;
                    return true;
                }
                return false;
            });
            removeClass(queryAll('.slider-item', carousel), activeClass);
            removeClass(queryAll('.image-slide-indicators li', carousel), activeClass);
            addClass(queryFirst('.image-slide-indicators li:nth-child(' + activeIndex + ')', carousel), activeClass);
            addClass(queryFirst('.slider-item:nth-child(' + activeIndex + ')', carousel), activeClass);
        }
    };
    const requestTick = () => {
        if (!ticking) {
            requestAnimationFrame(carouselIndicatorScroll);
        }
        ticking = true;
    };
    const onScroll = () => {
        currentScrollPos = window.scrollY || window.pageYOffset;
        requestTick(carousel);
    };
    $window.scroll(onScroll);
};

const initScrollSlider = carousels => {
    if (!Array.isArray(carousels)) {
        const array = [].slice.call(carousels, 0);
        carousels = array.length ? array : [carousels];
    }

    carousels.forEach(carousel => {
        if (queryFirst('.carousel-indicators:not(.jw-pdp)', carousel)) {
            handleDesktopCarousel(carousel);
        }

        initOnce(
            carousel,
            undefined,
            () => {
                if (queryFirst('.carousel-indicators:not(.jw-pdp)', carousel)) {
                    handleCarouselOnScroll(carousel);
                }
            },
            'scrollSlider'
        );
    });
};

$document.ready(function () {
    $('.carousel').each(function () {
        // Initilize carousel and stop swipe propagations only if slides count is more than 1
        if ($(this).find('.carousel-inner').length > 1) {
            $(this).carousel();
        }
    });

    $body.on('product:imageLoad', (e, response) => {
        let carousel = queryFirst('.carousel', response.container);
        const isScrollableProductItem = carousel && $(carousel).closest('.scrollable-product-item:not(.grid-product)').length;

        if (isScrollableProductItem) {
            let carouselIndicatorsElement = queryFirst('.carousel-indicators:not(.jw-pdp)', carousel);
            if (carouselIndicatorsElement) {
                addClass(carouselIndicatorsElement, 'image-slide-indicators');
                addClass(queryFirst('.carousel-inner', carousel), 'slider-inner');
                addClass(queryAll('.carousel-item', carousel), 'slider-item');
                remove(queryAll('.carousel > a'));
                initScrollSlider(carousel);
            }
        }
    });
});

$window.resize(
    throttle(() => {
        const pdpCarouselEl = queryFirst('.pdp-container .carousel.image-slider');
        if (pdpCarouselEl) {
            pdpCarouselEl.style.minHeight = '';
        }
    })
);

/**
 * Fixes a bug in Safari 15 where swiping on images is very difficult
 * due to safari being overly sensitive to diagonal scrolling
 * Solution adapted from: http://web.archive.org/web/20220415194859/https://wpdevdesign.com/fixing-flickitys-issue-with-ios15-safari/
 */
function initCarouselSwipeListener() {
    let isTouchingCarousel = false;
    let startCoord;

    document.addEventListener('touchstart', e => {
        isTouchingCarousel = !!e.target.closest('.carousel.image-slider');
        startCoord = getNestedValue(e, 'touches[0].pageX');
    });

    document.addEventListener('touchmove', e => {
        const currentCoord = getNestedValue(e, 'touches[0].pageX');
        const coordsAreNumbers = typeof startCoord === 'number' && typeof currentCoord === 'number';

        // don't do anything if the user isn't touching the carousel,
        // if the event isn't cancelable,
        // or if the user didn't scroll enough in the x direction (i.e. is scrolling vertically)
        if (!isTouchingCarousel || !e.cancelable || (coordsAreNumbers && Math.abs(currentCoord - startCoord) < 16)) {
            return;
        }

        e.preventDefault();
        e.stopPropagation();
    }, { passive: false });
}

initCarouselSwipeListener();